<!-- Custom Category -->

  <div class="border p-4 rounded card">
    <div class="mb-5 card-head">
      <h4 class="text-gray-700">
        Craft Your Book's Core
      </h4>
    </div>
    <div class="card-body p-0">
      <form [formGroup]="_extraInformationForm" class="d-flex flex-column">
        
      <ng-container *ngFor="let input of inputs;let i = index">
        <div class="mb-10">
        <label class="form-label" for="{{input.name}}_{{i}}">{{input.label}}</label>
      <input
      *ngIf="!input?.type || input?.type == 'text'"
        [(ngModel)]="input.value"
        (ngModelChange)="onUpdateValue()"
        [formControlName]="input.name"
        [placeholder]="input.placeholder ? input.placeholder : 'Enter your ' + input.label"
        class="form-control"
        id="{{input.name}}_{{i}}"
      />


      <textarea
      *ngIf="input?.type == 'textarea'"
        [(ngModel)]="input.value"
        (ngModelChange)="onUpdateValue()"
        [formControlName]="input.name"
        [placeholder]="input.placeholder ? input.placeholder : 'Enter your ' + input.label"
        class="form-control"
        id="{{input.name}}_{{i}}"
      ></textarea>


      <select
      *ngIf="input?.type == 'select'"
      class="form-select"
        [(ngModel)]="input.value"
        (ngModelChange)="onUpdateValue()"
        [formControlName]="input.name"
        id="{{input.name}}_{{i}}"
      >
      <option selected value="">Any</option>
      <!-- <option selected disabled value="">{{ input.placeholder }}</option> -->
    <option *ngFor="let option of input.options" [value]="option">{{ option }}</option>
    </select>
  </div>
    </ng-container>
  </form>
    </div>
  </div>

<!-- Custom Category -->